import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PoPageDefault, PoBreadcrumb, PoBreadcrumbItem,
  PoNotificationService, PoDialogService, PoTableColumn, PoSelectOption, PoModalComponent, PoModalAction, PoUploadFileRestrictions, PoStepperComponent
} from '@po-ui/ng-components';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DicionarioService } from 'src/app/services/dicionario/dicionario.service';
import { UtilService } from 'src/app/services/util-service/util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FsbcamposService } from 'src/app/services/campos/fsbcampos.service';
import { PreNotaPedidosService } from 'src/app/services/pre-nota-pedidos/pre-nota-pedidos.service';
import { SessionService } from 'src/app/services/session/session.service';
import { environment } from 'src/environments/environment';
import { GetDadosService } from 'src/app/services/get-dados/get-dados.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UploadService } from 'src/app/services/upload/upload.service';


// Controla o stepper, cada status representa um step 
type PreNotaStepperStatus =
  | 'Inicial'
  | 'PreNotaEnviada'
  | 'UploadEnviado'

@Component({
  selector: 'app-pre-nota-edit',
  templateUrl: './pre-nota-edit.component.html',
  styleUrls: ['./pre-nota-edit.component.css']
})
export class PreNotaEditComponent implements OnInit {

  @ViewChild('emailModal', { static: true }) emailModal: PoModalComponent;
  @ViewChild('modalVerificarPedido', { static: true }) modalVerificarPedido: PoModalComponent;
  @ViewChild(PoStepperComponent) preNotaStepper: PoStepperComponent;

  @ViewChild('mensagemGov2', { static: true }) mensagemGov2: PoModalComponent;



  public abrirMensagemGov() {
    this.mensagemGov2.open();
  }



  public emailModalPrimaryAction: PoModalAction = {
    label: 'Enviar',
    action: () => {
      this.preNotaCompraService.enviarEmail(this.emailForm.value)
        .subscribe(
          () => {
            this.notificationService.success('E-mail enviado com sucesso!');
          },
          err => {
            this.notificationService.error('Não foi possível enviar o e-mail.');
          });
    }
  };
  public emailModalSecondaryAction: PoModalAction = {
    label: 'Cancelar',
    action: () => {
      this.emailModal.close();
    }
  };

  // stepper variables
  stepper = {
    status: <PreNotaStepperStatus>"Inicial",
    isSent: () => this.stepper.status == "PreNotaEnviada",
    isUploaded: () => this.stepper.status == "UploadEnviado",
    numeroNota: ""
  }
  disabledButton = this.stepper.status != "Inicial"


  mostrarArquivos = false;
  labelButton = 'Exibir Arquivos';
  isAddPage = this.router.url.indexOf('add') !== -1
  uploadURL = `${environment.protheus}/upload`;
  fileRestrictions: PoUploadFileRestrictions = { allowedExtensions: ['.pdf', '.xml'] };
  tableConhecimento = {
    columns: <PoTableColumn[]>[
      { property: 'descricao', label: 'Nome Arquivo', width: '80%' },
    ],
    items: [],
    selectedItems: [],
    select(event) {
      this.tableConhecimento.selectedItems.push(event);
    },
    unselect(event) {
      this.tableConhecimento =
        this.tableConhecimento.selectedItems
          .filter(item => item.recno !== event.recno)
    },
    selectAll(event) {
      this.tableConhecimento.selectedItems.push(event);
    },
    unselectAll(event) {
      this.tableConhecimento.selectedItems = [];
    }
  }

  public page: PoPageDefault = {
    title: '',
    breadcrumb: {
      items: [] as PoBreadcrumbItem[]
    } as PoBreadcrumb,
    actions: []
  };

  public idPreNota = '';
  public tipoTela = '';
  public loading = true;
  public preNotaSelecionada: any;
  public allItens = false;
  public item: any[] = [];

  public disabledField = false;
  public disabledFieldEdit = false;
  public informacoesFornecedor = '';

  public dados = {
    F1_DOC: '',
    F1_SERIE: '',
    F1_EMISSAO: '',
    F1_ESPECIE: '',
    A2_CGC: '',
    A2_NOME: '',
    empresa: '',
    filial: '',
    F1_COND: ''
  };

  public dadosPedido: object = {};
  public arrHeaders: Array<object> = [];
  public arrFields: Array<object> = [];
  public fieldsColumns: PoTableColumn[];
  public tipoModal = '';
  public informacoes: any;
  public emailForm: FormGroup;

  public selects = {
    especieDocumento: {},
    ufOrigem: {},
    serieDocumento: [] as Array<PoSelectOption>
  };

  public table = {
    columns: [
      { property: 'D1_ITEMPC', label: 'Item Pedido', width: '160px', readonly: true, visible: false },
      { property: 'D1_COD', label: 'Código', width: '140px', readonly: true },
      { property: 'D1_QUANT', label: 'Quant', width: '140px' },
      { property: 'D1_VUNIT', label: 'Vlr. Unit', width: '140px', readonly: true },
      { property: 'D1_PEDIDO', label: 'Pedido', width: '140px', readonly: true },
      { property: 'C7_EMISSAO', label: 'Emissão', width: '140px', readonly: true },
    ] as any[],
    items: [],
    loading: false as boolean,
    height: 0,
  };

  tableItens = [];

  /* Criação do Modal de Inserir Item */

  public tableModal = {
    columns: [] as any[],
    items: [],
    loading: false as boolean,
    height: 0,
  };


  @ViewChild('modalInserirItem', { static: true }) modalInserirItem: PoModalComponent;

  confirmItem: PoModalAction = {
    label: 'Ok',
    action: () => {
      if (this.item.length <= 0) {
        this.notificationService.warning('Selecione um item do pedido !');
      } else {
        if (this.allItens === false && this.tableItens.length === 0) {
          this.tableItens = this.item;
          let count = 1;
          this.tableItens.map((item) => {
            const sequencia = count++;
            item.D1_ITEM = sequencia.toString().padStart(4, '0');
            item.D1_QUANT = 1;
            this.dados.F1_COND = item.F1_COND;
          });
        } else if (this.allItens === false && this.tableItens.length >= 0) {
          this.tableItens = this.item[0];
          let count = 1;
          this.tableItens.map((item) => {
            const sequencia = count++;
            item.D1_ITEM = sequencia.toString().padStart(4, '0');
            item.D1_QUANT = 1;
            this.dados.F1_COND = item.F1_COND;
          });
        } else {
          this.tableItens = this.item[0];
          let count = 1;
          this.tableItens.map((item) => {
            const sequencia = count++;
            item.D1_ITEM = sequencia.toString().padStart(4, '0');
            item.D1_QUANT = 1;
            this.dados.F1_COND = item.F1_COND;
          });
        }
        this.page.actions[0].disabled = false;
        this.modalInserirItem.close();
      }
    }
  };

  cancelItem: PoModalAction = {
    label: 'Cancelar', action: () => {
      this.modalInserirItem.close();
    }
  };

  /* Criação do Modal de Inserir Pedido */

  @ViewChild('modalInserirPedido', { static: true }) modalInserirPedido: PoModalComponent;

  confirmPedido: PoModalAction = {
    label: 'Ok',
    action: () => {
      if (this.item.length <= 0) {
        this.notificationService.warning('Selecione um pedido !');
      } else {
        if (this.allItens === false && this.tableItens.length === 0) {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < this.item.length; i++) {
            const element = this.item[i];
            if (element.D1_PEDIDO !== null || element.D1_PEDIDO !== undefined) {
              this.preNotaCompraService.getItemCompra(this.informacoes.FORNECEDOR[0].A2_CGC, element.D1_PEDIDO)
                .subscribe((data: any) => {
                  this.tableItens.push(...data.dados);
                  console.log(this.tableItens);
                  let count = 1;
                  this.tableItens.map((item) => {
                    const sequencia = count++;
                    item.D1_ITEM = sequencia.toString().padStart(4, '0');
                    item.D1_QUANT = 1;
                    this.dados.F1_COND = item.F1_COND;
                  });
                }, (err: HttpErrorResponse) => {
                  console.error(err);
                });

            }
          }
        } else if (this.allItens === false && this.tableItens.length >= 0) {
          const itemReal = this.item[0];
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < itemReal.length; i++) {
            const element = itemReal[i];
            if (element.D1_PEDIDO != null || element.D1_PEDIDO !== undefined) {
              this.preNotaCompraService.getItemCompra(this.informacoes.FORNECEDOR[0].A2_CGC, element.D1_PEDIDO)
                .subscribe((data: any) => {
                  this.tableItens.push(...data.dados);
                  let count = 1;
                  this.tableItens.map((item) => {
                    const sequencia = count++;
                    item.D1_ITEM = sequencia.toString().padStart(4, '0');
                    item.D1_QUANT = 1;
                    this.dados.F1_COND = item.F1_COND;
                  });
                  console.log(this.tableItens);
                }, (err: HttpErrorResponse) => {
                  console.error(err);
                });

            }
          }
        } else {
          const itemReal = this.item[0];
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < itemReal.length; i++) {
            const element = itemReal[i];
            if (element.D1_PEDIDO != null || element.D1_PEDIDO !== undefined) {
              this.preNotaCompraService.getItemCompra(this.informacoes.FORNECEDOR[0].A2_CGC, element.D1_PEDIDO)
                .subscribe((data: any) => {
                  this.tableItens.push(...data.dados);
                  let count = 1;
                  this.tableItens.map((item) => {
                    const sequencia = count++;
                    item.D1_ITEM = sequencia.toString().padStart(4, '0');
                    item.D1_QUANT = 1;
                    this.dados.F1_COND = item.F1_COND;
                  });
                  console.log(this.tableItens);
                }, (err: HttpErrorResponse) => {
                  console.error(err);
                });

            }
          }
        }
        this.page.actions[0].disabled = false;
        this.modalInserirPedido.close();
      }

    }
  };

  cancelPedido: PoModalAction = {
    label: 'Cancelar', action: () => {
      this.modalInserirPedido.close();
    }
  };

  constructor(
    private notificationService: PoNotificationService,
    private poDialog: PoDialogService,
    private location: Location,
    private router: Router,
    private actRoute: ActivatedRoute,
    private dicionarioService: DicionarioService,
    private utilService: UtilService,
    private fsbCampos: FsbcamposService,
    private preNotaCompraService: PreNotaPedidosService,
    private sessionService: SessionService,
    private getDadosService: GetDadosService,
    private poAlert: PoDialogService,
    private fb: FormBuilder,
    private uploadService: UploadService
  ) { }

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      to: [this.sessionService.emailGestor, [Validators.required]],
      message: ['', [Validators.required]]
    });

    this.sessionService.info$
      .subscribe((data) => {
        this.informacoes = data;
      });

    this.informacoesFornecedor = ` Informações do Cabeçalho  CNPJ: ${this.informacoes.FORNECEDOR[0].A2_CGC} - NOME: ${this.informacoes.FORNECEDOR[0].A2_NOME}`;

    if (this.router.url.indexOf('add') !== -1) {
      this.tipoTela = 'add';
      this.page.title = 'Incluir Nota Fiscal';
      this.modalVerificarPedido.open();
      this.page.actions = [
        {
          label: this.stepper.isUploaded() ? 'Voltar' : 'Ok', disabled: this.disabledButton, action: () => {
            if (this.stepper.isUploaded()) {
              this.router.navigate(['/nota-fiscal']);
              return;
            } else {
              this.salvarPreNota();
              return;
            }
          }
        },
        { label: 'Inserir Pedido', disabled: this.disabledButton, separator: true, icon: 'po-icon po-icon-sale', action: () => { this.addPedido(); } },
        { label: 'Cancelar', disabled: this.disabledButton, action: () => this.cancelarFn() },
        { label: 'Inserir Item Pedido', disabled: this.disabledButton, separator: true, icon: 'po-icon po-icon-plus', action: () => { this.addItemPedido(); } },
        { label: 'Enviar E-mail', disabled: this.disabledButton, separator: true, icon: 'po-icon po-icon-mail', action: () => { this.emailModal.open(); } },
      ];
      this.page.actions[0].disabled = true;
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Nota Fiscal' },
        { label: 'Inclusão de Nota Fiscal' },
      ];
      this.getDicionario();
      this.dados.A2_CGC = this.tipoTela === 'add' ? this.informacoes.FORNECEDOR[0].A2_CGC : '';
      this.dados.A2_NOME = this.tipoTela === 'add' ? this.informacoes.FORNECEDOR[0].A2_NOME : '';
      // this.dados.F1_SERIE =  this.sessionService.isPJ ? 'UNI' : '';

      // const arrSerie = this.informacoes.F1_SERIE.map((item) => {
      //   return { label: item, value: item } as PoSelectOption;
      // });
      // this.selects.serieDocumento = arrSerie;


    } else if (this.router.url.indexOf('edit') !== -1) {
      this.tipoTela = 'edit';
      this.page.title = 'Alterar Nota Fiscal';
      this.page.actions = [
        { label: 'Ok', action: () => { this.salvarPreNota(); } },
        { label: 'Cancelar', action: () => this.cancelarFn() },
        { label: 'Inserir Item Pedido', separator: true, icon: 'po-icon po-icon-plus', action: () => { this.addItemPedido(); } },
        { label: 'Inserir Pedido', separator: true, icon: 'po-icon po-icon-sale', action: () => { this.addPedido(); } }
      ];
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Nota Fiscal' },
        { label: 'Alteração de Nota Fiscal' },
      ];
      this.actRoute.paramMap.subscribe((paramMap: ParamMap) => {
        this.idPreNota = paramMap.get('idPreNota');
      });
      this.getDicionario();
      this.disabledFieldEdit = false;
      this.disabledField = true;
    } else if (this.router.url.indexOf('view') !== -1) {
      this.tipoTela = 'view';
      this.page.title = 'Visualizar Nota Fiscal';
      this.page.actions = [
        { label: 'Ok', disabled: true },
        { label: 'Cancelar', action: () => this.cancelarFn() },
      ];
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Nota Fiscal' },
        { label: 'Visualização de Nota Fiscal' },
      ];
      this.actRoute.paramMap.subscribe((paramMap: ParamMap) => {
        this.idPreNota = paramMap.get('idPreNota');
      });
      this.getDicionario();
      this.disabledField = true;
      this.disabledFieldEdit = true;
    } else {
      this.tipoTela = 'delete';
      this.page.title = 'Excluir Nota Fiscal';
      this.page.actions = [
        { label: 'Ok', action: () => { this.salvarPreNota(); } },
        { label: 'Cancelar', action: () => this.cancelarFn() },
      ];
      this.page.breadcrumb.items = [
        { label: 'Home' },
        { label: 'Nota Fiscal' },
        { label: 'Excluir Nota Fiscal' },
      ];
      this.actRoute.paramMap.subscribe((paramMap: ParamMap) => {
        this.idPreNota = paramMap.get('idPreNota');
      });
      this.getDicionario();
      this.disabledField = true;
      this.disabledFieldEdit = true;
    }
  }

  private getDicionario(tabela?: string) {
    this.loading = true;
    const param = {
      tabela: 'SF1'
    };
    this.dicionarioService
      .fsbDicionario(this.utilService.getParameters(param))
      .subscribe((ret: any) => {

        let auxiliarColumns: Array<any> = ret.dados[0].dynamicView[0].fields;

        auxiliarColumns = auxiliarColumns.filter(item => item.used === true);

        this.fsbCampos.getCampos('prnf')
          .subscribe((data: any) => {

            this.arrHeaders = [];

            /* Inicio da lógica dos headers*/

            const header = [];

            auxiliarColumns.filter((element) => {
              if (data.header.indexOf(element.property) === -1) {
                return element;
              }
              return header.push(element);
            });

            // console.log(header);


            header.sort((a, b) => {
              if (a.sequence < b.sequence) {
                return -1;
              } else if (a.sequence > b.sequence) {
                return 1;
              } else {
                return 0;
              }
            });


            header.map((item, i: number) => {
              let select = false;
              let options: Array<PoSelectOption> = [];
              if (item.property === 'F1_SERIE') {
                select = true;
                options = [
                  { label: this.informacoes.F1_SERIE[0].trim(), value: this.informacoes.F1_SERIE[0].trim() }
                ];
              } else if (item.option.length > 0) {
                select = true;
                const arr: Array<string> = item.option.split(';');
                options = arr.map((val) => {
                  const d = val.split('=');
                  return { value: d[0], label: d[1] } as PoSelectOption;
                });
              }

              this.arrHeaders.push({
                property: item.property,
                label: item.label,
                type: item.TIPO,
                f3: item.F3.length > 0 ? true : false,
                readonly: (item.property === 'F1_SERIE' && this.tipoTela === 'add') || (item.property === 'F1_XREJEI') || item.readonly,
                //readonly: (item.property === 'F1_XREJEI') || item.readonly,
                options,
                select,
                tabela: item.F3,
                tamanho: item.width,
                ordem: 0
              });

              this.defineSequenciaArrayCabecalho(this.arrHeaders);

              console.log(this.arrHeaders, `HEADERS`);
              this.utilService.sortArrayByProperty(this.arrHeaders, 'ordem');
              // this.verificaAlteracaoEspecieDocumento('',this.dados)

            });
            /* Fim da lógica dos headers*/

            /* Inicio da lógica dos fields*/


            if (this.tipoTela === 'add') {
              this.dados.F1_SERIE = this.informacoes.F1_SERIE[0].trim(); // valor padrão
            }

            const fields = [];

            this.arrFields = auxiliarColumns.filter((element, index, array) => {

              if (data.fields.indexOf(element.property) === -1) {
                return element;
              }
              return fields.push(element);
            });

            fields.sort((a, b) => {
              if (a.sequence < b.sequence) {
                return -1;
              } else if (a.sequence > b.sequence) {
                return 1;
              } else {
                return 0;
              }
            });

            fields.map((item) => {
              let select = false;
              let options: Array<PoSelectOption> = [];
              if (item.option.length > 0) {
                select = true;
                const arr: Array<string> = item.option.split(';');
                options = arr.map((val) => {
                  const d = val.split('=');
                  return { value: d[0], label: d[1] } as PoSelectOption;
                });
              }

              this.arrFields.push({
                property: item.property, label: item.label, type: item.TIPO,
                f3: item.F3.length > 0 ? true : false, readonly: item.readonly,
                options, select, tabela: item.F3
              });

              let pixels: number = parseInt(item.width, 10) * 25;
              if (pixels <= 125) {
                pixels = 125;
              } else if (pixels > 200) {
                pixels = 200;
              } else {
                pixels = parseInt(item.width, 10) * 25;
              }

              let obj: PoTableColumn = {};

              let typeTable = '';
              let formatTable = '';

              if (item.TIPO === 'D') {
                typeTable = 'date';
                formatTable = 'dd/MM/yyyy';
              } else if (item.TIPO === 'N') {
                obj.type = 'number';
              }

              obj = { label: item.label, property: item.property, width: `${pixels}px`, type: `${typeTable}`, format: `${formatTable}` };

              this.table.columns.push(obj);
            });


            /* Fim da lógica dos fields*/

          });

        /* Select de Especie do Documento */

        const especie = this.actRoute.snapshot.data.especie.dados;
        console.log({ especie })
        const arrEspecie = especie.map((item) => {
          return { label: item.X5_DESCRI, value: item.X5_CHAVE } as PoSelectOption;
        });
        this.selects.especieDocumento = arrEspecie;

        const dadosHeader = {
          registro: this.idPreNota,
          tabela: 'SF1'
        };

        this.getDetailHeader(this.utilService.getParameters(dadosHeader));

        const dadosFields = {
          registro: this.idPreNota,
          tabela: 'SD1'
        };

        this.getDetailFields(this.utilService.getParameters(dadosFields));
        // this.loading = false;
      },
        (error: HttpErrorResponse) => {
          this.notificationService.error('Error ao carregar os dados!');
          console.error(error.error);
        });
  }

  private defineSequenciaArrayCabecalho(array: Array<any>): Array<any> {

    const proximoItem = array.length;
    return array.map((item, i: number) => {
      switch (item.property) {
        case 'F1_DOC':
          item.ordem = 1
          break
        case 'F1_SERIE':
          item.ordem = 2
          break
        case 'F1_COND':
          item.ordem = 4
          break
        case 'F1_EMISSAO':
          item.ordem = 3
          break
        case 'F1_ESPECIE':
          item.ordem = 0
          break
        case 'F1_XREJEIC':
          item.ordem = 5
          break
        default:
          item.ordem = proximoItem
          break;
      }
    })
  }

  private cancelarFn() {
    this.poDialog.confirm({
      title: `Deseja Cancelar a ${this.tipoTela === 'add' ? 'Inserção' : this.tipoTela === 'edit' ? 'Edição' : this.tipoTela === 'view' ? 'Visualização' : 'Exclusão'}?`,
      message: `${this.tipoTela === 'view' || this.tipoTela === 'delete' ? '' : 'Você irá perder todos os dados digitados.'}`,
      confirm: () => this.location.back(),
      literals: { confirm: 'Sim', cancel: 'Não' }
    });
  }

  /* Funções para o Modal  */

  addItemPedido() {
    if (this.tableItens.length > 0) {
      this.poDialog.confirm({
        title: `Deseja selecionar os dados novamente ?`,
        message: 'Você irá perder todos os dados selecionados anteriormente.',
        confirm: () => {
          this.tableItens = [];
          this.item = [];
          this.tipoModal = 'item';
          this.retornarItensModal();
          this.page.actions[0].disabled = true;
        },
        literals: { confirm: 'Sim', cancel: 'Não' }
      });
    } else {
      this.tipoModal = 'item';
      this.retornarItensModal();
    }
  }

  addPedido() {
    if (this.tableItens.length > 0) {
      this.poDialog.confirm({
        title: `Deseja selecionar os dados novamente ?`,
        message: 'Você irá perder todos os dados selecionados anteriormente.',
        confirm: () => {
          this.tableItens = [];
          this.item = [];
          this.tipoModal = 'pedido';
          this.retornarItensModal();
          this.page.actions[0].disabled = true;
        },
        literals: { confirm: 'Sim', cancel: 'Não' }
      });
    } else {
      this.tipoModal = 'pedido';
      this.retornarItensModal();
    }
  }


  public selected(event) {
    this.allItens = false;
    this.item.push(event);

  }

  public unSelected(event) {
    if (this.item[0].length > 0) {
      this.item = this.item[0].filter(item => item.REGISTRO !== event.REGISTRO);
    } else {
      this.item = this.item.filter(item => item.REGISTRO !== event.REGISTRO);
    }
  }

  // marcar todas as linhas
  allSelected(event: any) {
    this.allItens = true;
    this.item.push(event);
  }
  // desmarcar todas as linhas
  unAllSelected(event: any) {
    this.allItens = false;
    this.item = [];
  }

  retornarItensModal() {
    this.loading = true;
    const CNPJ = this.informacoes.FORNECEDOR[0].A2_CGC;
    if (this.tipoModal === 'pedido') {
      this.preNotaCompraService.getCompra(CNPJ)
        .subscribe((data: any) => {
          this.tableModal.columns = [
            { property: 'D1_PEDIDO', label: 'Pedido de Compra', width: '25%' },
            { property: 'C7_EMISSAO', label: 'Emissão', width: '25%', type: 'date', format: 'dd/MM/yyyy' },
            { property: 'QUANTIDADE', label: 'Quant', width: '25%' },
            { property: 'TOTAL', label: 'Valor', width: '25%' },
          ];
          this.tableModal.items = data.dados;
          this.modalInserirPedido.open();
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
    } else {
      this.loading = true;
      this.preNotaCompraService.getItemCompra(CNPJ, '')
        .subscribe((data: any) => {
          this.tableModal.columns = [
            { property: 'D1_PEDIDO', label: 'Pedido de Compra', width: '14%' },
            { property: 'C7_EMISSAO', label: 'Emissão', width: '14%', type: 'date', format: 'dd/MM/yyyy' },
            { property: 'D1_ITEMPC', label: 'Item Pedido', width: '16%' },
            { property: 'D1_COD', label: 'Código', width: '14%' },
            { property: 'D1_LOCAL', label: 'Local', width: '14%' },
            { property: 'D1_QUANT', label: 'Quant', width: '14%' },
            { property: 'D1_VUNIT', label: 'Vlr. Unit', width: '14%' },
          ];
          this.tableModal.items = data.dados;
          this.modalInserirItem.open();
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
    }
  }

  calculaPrecoAplicado(item) {
    if (item.D1_QUANT > item.SALDO) {
      item.D1_QUANT = item.SALDO;
      this.notificationService.warning(`O saldo máximo do item disponível para lançamento é : ${item.SALDO} `);
    }
    const precoAplicado = item.D1_QUANT * item.D1_VUNIT;
    item.D1_TOTAL = precoAplicado.toFixed(2);

  }

  private salvarPreNota() {
    const validaSerie = this.dados.F1_SERIE.length > 0 ? true : false;
    const validaNotaFiscal = parseInt(this.dados.F1_DOC) > 0 ? true : false;
    if (!validaSerie) {
      return this.notificationService.warning('O campo Series é obrigatório, por favor verifique o preenchimento e tente novamente!');
    } else if (!validaNotaFiscal) {
      return this.notificationService.warning('O campo Invoice deve ser maior que 0, por favor verifique o preenchimento e tente novamente!');
    } else {
      this.loading = true;
      const envio = {
        F1_DOC: this.dados.F1_DOC.toString(),
        F1_SERIE: this.dados.F1_SERIE,
        F1_EMISSAO: this.dados.F1_EMISSAO,
        F1_ESPECIE: this.dados.F1_ESPECIE,
        F1_COND: this.dados.F1_COND,
        A2_CGC: this.dados.A2_CGC,
        A2_NOME: this.dados.A2_NOME,
        empresa: 'empresa',
        filial: 'filial'
        // "empresa": this.dados['empresa'],
        // "filial": this.dados['filial']
      };
      // console.log(envio);

      // tslint:disable-next-line: max-line-length
      // if (envio['F1_COND'] == '' || envio['F1_DOC'] == '' || envio['F1_EMISSAO'] == '' || envio['F1_ESPECIE'] == '' || envio['F1_SERIE'] == '' || envio['empresa'] == '' || envio['filial'] == '') {
      //   this.notificationService.warning('O preenchimento dos campos do cabeçalho é obrigatório, preencha-os e tente novamente');
      //   this.loading = false;
      // } else {

      const obj = this.tableItens;

      const final: any = [];

      let itens: any;

      obj.map((item) => {

        itens = {
          C7_EMISSAO: item.C7_EMISSAO,
          D1_COD: item.D1_COD,
          D1_ITEM: item.D1_ITEM,
          D1_ITEMPC: item.D1_ITEMPC,
          D1_LOCAL: item.D1_LOCAL,
          D1_PEDIDO: item.D1_PEDIDO,
          D1_QUANT: item.D1_QUANT,
          D1_TOTAL: item.D1_TOTAL,
          D1_VUNIT: item.D1_VUNIT,
          D1_XHISTOR: item.D1_XHISTOR === undefined ? '' : item.D1_XHISTOR,

        };

        final.push(itens);
      });

      // Sendo 3 para Incluir, 4 para alterar e 5 Excluir.

      const opcao = this.tipoTela === 'add' ? 3 : this.tipoTela === 'edit' ? 4 : 5;

      const postJson = { OPCAO: opcao, CABEC: envio, ITEM: final };
      console.log(postJson);

      this.preNotaCompraService.salvarPreNota(postJson)
        .subscribe((data: any) => {
          console.log(data);

          if (data.gravado === false) {
            this.poAlert.alert({
              title: `Erro ao ${this.tipoTela === 'add' ? 'Inserir Nota Fiscal ' : this.tipoTela === 'edit' ? 'Editar Nota Fiscal' : 'Excluir Nota Fiscal'}`,
              message: data.mensagem,
              ok: () => ('')
            });
            this.router.navigate(['/nota-fiscal']);
            this.loading = false;
          } else {
            if (this.tipoTela === 'add') {
              this.poAlert.alert({
                title: 'Atenção',
                message: data.mensagem,
                ok: () => ('')
              });
              this.idPreNota = data.REGISTRO;
              this.stepper.numeroNota = data.F1_DOC;
              this.stepper.status = "PreNotaEnviada";
              this.preNotaStepper.next();
              this.loading = false;
            } else {
              this.notificationService.success(data.mensagem);
              this.router.navigate(['/nota-fiscal']);
              this.loading = false;
            }
          }
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.poAlert.alert({
              title: `Erro ao ${this.tipoTela === 'add' ? 'Inserir Nota Fiscal ' : this.tipoTela === 'edit' ? 'Editar Nota Fiscal' : 'Excluir Nota Fiscal'}`,
              message: error.message,
              ok: () => ('')
            });
            this.loading = false;
          });
      // }
    }
  }

  private getDetailHeader(parameters: any) {
    this.loading = true;
    this.getDadosService
      .getBrowserDetail(parameters)
      .subscribe((data: any) => {
        console.log('header', data);

        this.dados = Object.assign(this.dados, data.dados[0]);
        this.dados.A2_CGC = this.informacoes.FORNECEDOR[0].A2_CGC;
        this.dados.A2_NOME = this.informacoes.FORNECEDOR[0].A2_NOME;
        // this.loading = false;
      },
        (error: HttpErrorResponse) => {
          console.log('Error ao obter detalhes da Pré Nota', error.error);
          this.loading = false;
        });
  }

  private getDetailFields(parameters: any) {
    // this.loading = true;
    this.getDadosService
      .getBrowserDetail(parameters)
      .subscribe((data: any) => {
        console.log('fields', data);

        this.tableItens = data.dados;
        this.dados = Object.assign(this.dados, this.tableItens[0]);
        this.loading = false;
      },
        (error: HttpErrorResponse) => {
          console.log('Error ao obter detalhes do Pedido', error.error);
          this.loading = false;
        });
  }

  public verificaAlteracaoEspecieDocumento(item: string, form: any) {
    // const arrMap = this.arrHeaders.map((item: any) => item.property)
    // const indice = arrMap.indexOf("F1_SERIE")

    // if (item === 'FAT') {
    //   form.F1_SERIE = 'FAT';
    //   this.arrHeaders[indice]['readonly'] = true
    // } else {
    //   form.F1_SERIE = '';
    //   this.arrHeaders[indice]['readonly'] = false
    // }

  }

  uploadError(err: HttpErrorResponse) {
    console.log(err);
    if (err.ok === false) {
      this.poDialog.alert({
        title: `Erro ao anexar documento`,
        message: err.error.errorMessage,
        ok: () => ('')
      });
      this.loading = false;
    }
  }

  uploadSuccess(err: HttpErrorResponse) {
    if (!err.ok) {
      console.log("upload error: ", err)
      return
    }

    this.notificationService.success('Arquivo enviado com sucesso')
    this.stepper.status = "UploadEnviado"
    this.preNotaStepper.next()
    this.loading = false;
  }

  exibeFiles() {
    this.mostrarArquivos = !this.mostrarArquivos;
    if (this.mostrarArquivos === true) {
      this.labelButton = 'Ocultar Arquivos';
    } else {
      this.labelButton = 'Exibir Arquivos';
    }
  }

  public retornaFiles(registro: any) {
    this.loading = true;
    this.uploadService.listFiles('SF1', registro)
      .subscribe((data: any) => {
        this.tableConhecimento.columns = [
          { property: 'descricao', label: 'Nome Arquivo', width: '80%' },
        ];
        this.tableConhecimento.items = data.arquivos;
        this.tableConhecimento.items.map((item) => {
          item.actions = ['baixar', 'remover'];
        });
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.notificationService.error('Não foi possível recuperar os arquivos desta Nota Fiscal, por favor tente novamente');
      });
  }

  public anexaArquivo(event) {
    this.uploadService.uploadHandler(event, {
      arquivo: event.file.name,
      extensao: event.file.extension,
      aliasTabela: 'SF1',
      registro: this.idPreNota,
    });
    setTimeout(() => {
      this.retornaFiles(this.idPreNota);
    }, 2000);
  }

  downloadFiles() {
    console.log(this.item);
    const arr = this.item.map((ret, index) => {
      return ret[index].recno.toString();
    });
    this.uploadService.downloadFile(arr)
      .subscribe((data: any) => {
        console.log(data);

        const blob = new Blob([data],);
        const url = window.URL.createObjectURL(blob);
        console.log(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = `${Date.now()}.zip`;
        document.body.append(el);
        el.click();
        this.notificationService.success('Arquivo baixado com sucesso!');
      });
  }
}
